import { gql } from '@graphql/__generated__';
import type { TourModule } from '@modules/product-updates/tours/tourTypes';

export const LISTING_BUYERS_ANCHORS = {
  view: 'listing-buyers-view',
  filters: 'listing-buyers-filters',
  selectAll: 'listing-buyers-select-all',
  matching: 'listing-buyers-matching',
} as const;

const GET_TOUR_LISTING_WITH_BUYERS = gql(/* GraphQL */ `
  query GetListingBuyersTourListing($userId: uuid!) {
    withBuyers: lots(
      where: { broker_id: { _eq: $userId }, buyer_leads: {} }
      order_by: [{ created_at: desc }]
      limit: 1
    ) {
      id
    }
    any: lots(
      where: { broker_id: { _eq: $userId } }
      order_by: [{ created_at: desc }]
      limit: 1
    ) {
      id
    }
    visibleWithBuyers: lots(
      where: { buyer_leads: {} }
      order_by: [{ created_at: desc }]
      limit: 1
    ) {
      id
    }
  }
`);

// The Buyers tab dashboard (`ListingBuyersDashboard.tsx`). Played from "Show
// me" on the entries listing-buyers-dashboard, buyer-leads-brochure-filter and
// buyer-leads-quick-select.
export const listingBuyersTour: TourModule = {
  steps: t => [
    {
      anchor: LISTING_BUYERS_ANCHORS.view,
      title: t('Dashboard or Kanban'),
      body: t(
        'The Buyers tab opens on this dashboard. Switch to Kanban to move buyers between stages.',
      ),
      placement: 'bottom-start',
    },
    {
      anchor: LISTING_BUYERS_ANCHORS.filters,
      title: t('Find the right buyers'),
      body: t(
        'Filter by next activity, overdue tasks, brochure opens or offers. Brochure shows who opened their link.',
      ),
      placement: 'bottom-start',
    },
    {
      anchor: LISTING_BUYERS_ANCHORS.selectAll,
      title: t('Select and act'),
      body: t(
        'Tick buyers, or select them all, then use Bulk actions to email them or move them to another stage.',
      ),
      placement: 'right',
    },
    {
      anchor: LISTING_BUYERS_ANCHORS.matching,
      title: t('Matching'),
      body: t(
        'Buyers whose search fits the listing appear here. Auto-matching can email new matches for you.',
      ),
      placement: 'left',
    },
  ],
  // The user's latest listing with buyers, else their latest listing, else
  // the latest listing with buyers they can see (staff, agents without
  // listings of their own).
  resolvePath: async ({ client, userId }) => {
    const { data } = await client.query({
      query: GET_TOUR_LISTING_WITH_BUYERS,
      variables: { userId },
      fetchPolicy: 'network-only',
    });
    const lotId =
      data?.withBuyers[0]?.id ??
      data?.any[0]?.id ??
      data?.visibleWithBuyers[0]?.id;
    return lotId == null
      ? null
      : `/listings/${lotId}/buyers?buyers_view=dashboard`;
  },
};
